import {
  SET_USER,
  CLEAR_USER,
  SET_USER_PAY,
  SET_TOKEN,
  SET_REFERRAL_CODE,
} from "./userActions";

const setLocalStorage = (key, value, expiryValue = null, unit = "days") => {
  const now = new Date();
  let expiry = null;

  if (expiryValue) {
    if (unit === "days") {
      expiry = now.getTime() + expiryValue * 24 * 60 * 60 * 1000;
    } else if (unit === "minutes") {
      expiry = now.getTime() + expiryValue * 60 * 1000;
    }
  }

  const item = { value, expiry };
  localStorage.setItem(key, JSON.stringify(item));
};

const getLocalStorage = (key) => {
  const itemStr = localStorage.getItem(key);
  if (!itemStr) return null;

  try {
    const item = JSON.parse(itemStr);

    if (!item.expiry) return item.value;

    const now = new Date();
    if (now.getTime() > item.expiry) {
      localStorage.removeItem(key);
      return null;
    }
    return item.value;
  } catch (err) {
    return null;
  }
};

let initialState = {
  user: null,
  token: null,
  referralCode: null,
};

const localStorageUser = getLocalStorage("paramUserStore");
const localStorageToken = getLocalStorage("paramToken");
const localStorageReferralCode = getLocalStorage("paramReferralCode");

if (localStorageToken) {
  initialState.token = localStorageToken;
}
if (localStorageUser) {
  // Only restore user if token is also present
  if (localStorageToken) {
    initialState.user = localStorageUser;
  } else {
    // Token expired/missing → clear stale user data
    localStorage.removeItem("paramUserStore");
  }
}
if (localStorageReferralCode)
  initialState.referralCode = localStorageReferralCode;

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER: {
      const { user } = action.payload;
      setLocalStorage("paramUserStore", user, 25, "days");

      return { ...state, user };
    }
    case SET_TOKEN: {
      const { token } = action.payload;
      setLocalStorage("paramToken", token, 25, "days");
      return { ...state, token };
    }

    case CLEAR_USER: {
      localStorage.removeItem("paramUserStore");
      localStorage.removeItem("paramToken");
      localStorage.removeItem("paramReferralCode");

      return {
        ...state,
        user: null,
        token: null,
        referralCode: null,
      };
    }

    case SET_USER_PAY: {
      const { formData } = action.payload;

      const updatedUser = {
        ...state.user,
        name: formData.name,
        email: formData.email,
        state: formData.state,
        district: formData.district,
        contactNo: formData.contactNo,
        pincode: formData.pincode,
        address: formData.address,
      };

      setLocalStorage("paramUserStore", updatedUser, 25, "days");

      return { ...state, user: updatedUser };
    }

    case SET_REFERRAL_CODE: {
      const { referralCode } = action.payload;

      setLocalStorage("paramReferralCode", referralCode, 1, "days");

      return { ...state, referralCode };
    }

    default:
      return state;
  }
};

export default userReducer;
